import store from "../modules/redux/store";
import config from './../config/config.json';
export const formatCurrency = (value) => {
    const currency = config.defaultCurrency;

    return currency.symbol + ' ' + (value.toFixed(currency.decimal_count));
}

export const formatPrice = (value, code = true) => {
    const currency = config.defaultCurrency;
    let userPreferred;
    try {
        const stored = localStorage.getItem('upc');
        userPreferred = stored ? JSON.parse(atob(stored)) : currency;
    } catch (e) {
        console.log(e);
        userPreferred = currency;
    }
    return code ? userPreferred.symbol + '' + ((value * userPreferred.conversion_rate).toFixed(userPreferred.decimal_count)) : ((value * userPreferred.conversion_rate).toFixed(userPreferred.decimal_count));
}

export const getTimeStamp = (date) => {
    const formattedDate = date.getFullYear() + "-" +
        String(date.getMonth() + 1).padStart(2, '0') + "-" +
        String(date.getDate()).padStart(2, '0') + " " +
        String(date.getHours()).padStart(2, '0') + ":" +
        String(date.getMinutes()).padStart(2, '0') + ":" +
        String(date.getSeconds()).padStart(2, '0');
    return formattedDate;
}

export const getProductSalePrice = (prod) => {
    // Check if there are no discount dates
    if (prod.discount_start_date === null && prod.discount_end_date === null) {
        return {
            price: formatPrice(prod.selling_price),
            discount: false,
        }
    } else {
        // Parse discount end date
        const discountEndDate = new Date(prod.discount_end_date);
        const currentDate = new Date();
        if (discountEndDate > currentDate) {
            // Valid discount
            return {
                price: formatPrice(prod.discounted_price),
                discount: true,
            }
        } else {
            // Discount expired
            return {
                price: formatPrice(prod.selling_price),
                discount: false,
            }
        }
    }
};

export const updateLang = (lang) => {
    localStorage.setItem('lang', lang === 'en' ? 'ar' : 'en');
    window.location.reload();
}

export const encrypt = async (data) => {
    const SECRET_KEY = import.meta.env.VITE_APP_ENCRYPT_KEY;
    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey(
        "raw",
        encoder.encode(SECRET_KEY),
        {
            name: "AES-GCM"
        },
        false,
        ["encrypt"]
    );
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encrypted = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv
        },
        key,
        encoder.encode(JSON.stringify(data))
    );
    return {
        iv: btoa(String.fromCharCode(...iv)),
        data: btoa(String.fromCharCode(...new Uint8Array(encrypted)))
    };
}
